import { gql } from '@apollo/client'

export const GET_ALL_FORM_FIELDS_BY_FORM_ID = gql`
  query GetAllFormFieldsByFormId(
    $formId: Int!
    $searchQuery: String
    $limit: Int
    $offset: Int
  ) {
    getAllFormFieldsByFormId(
      formId: $formId
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      rows {
        id
        form_id
        label
        name
        placeholder
        field_type_id
        field_type_choosen_source_id
        order
        col_width
        file_types_allowed
        TypeOfField {
          id
          name
          description
          type
        }
        TypeChoosenSourceOfField {
          id
          source_table
          key
          label
          source_json
        }
        FieldYupRulesOfFormField {
          id
          field_id
          yup_rule_id
          YupRuleOfField {
            id
            description
            yup_type
            yup_rule
            options
            message
          }
        }
      }
      count
    }
  }
`

export const GET_ONE_FORM_FIELD_BY_ID = gql`
  query GetOneFormFieldById($formFieldId: Int!) {
    getOneFormFieldById(formFieldId: $formFieldId) {
      id
      form_id
      label
      name
      placeholder
      field_type_id
      field_type_choosen_source_id
      order
      col_width
      file_types_allowed
      TypeOfField {
        id
        name
        description
        type
      }
      TypeChoosenSourceOfField {
        id
        source_table
        key
        label
        source_json
      }
      FieldYupRulesOfFormField {
        id
        field_id
        yup_rule_id
        YupRuleOfField {
          id
          description
          yup_type
          yup_rule
          options
          message
        }
      }
    }
  }
`

export const CREATE_FORM_FIELD = gql`
  mutation CreateFormField($input: FormFieldInput!) {
    createFormField(input: $input)
  }
`

export const UPDATE_FORM_FIELD = gql`
  mutation UpdateFormField($id: Int!, $input: FormFieldInput!) {
    updateFormField(id: $id, input: $input)
  }
`

export const DELETE_FORM_FIELD = gql`
  mutation DeleteFormField($id: Int!) {
    deleteFormField(id: $id)
  }
`
